var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-2h82v82H-1z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "darkorange",
    d: "M18.2 13.14a7.23 7.23 0 0 1-7.2 7.23c-4 0-4.32-7.23-4.32-7.23S7 5.92 11 5.92a7.22 7.22 0 0 1 7.2 7.22zM66.49 12.22a7.22 7.22 0 0 1-7.22 7.22c-4 0-4.33-7.22-4.33-7.22S55.28 5 59.27 5a7.22 7.22 0 0 1 7.22 7.22z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.96,
    cy: 33.68,
    r: 7.42,
    fill: "darkorange"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "darkorange",
    d: "M20.13 79.35V50.79c0-4.11 1.3-5.8 5.72-5.8h12.39a3.66 3.66 0 0 1 3.52 3.55V76.3a3.18 3.18 0 0 1-3.29 3l-18.34.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M29.68 56a1.5 1.5 0 0 0-1.5 1.5v21.85a1.5 1.5 0 0 0 3 0V57.46a1.5 1.5 0 0 0-1.5-1.46zM50.32 56a1.5 1.5 0 0 0-1.5 1.5v21.85a1.5 1.5 0 0 0 3 0V57.46a1.5 1.5 0 0 0-1.5-1.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M70.52 21h-1.06a10.71 10.71 0 1 0-10.63 0h-.78a9.47 9.47 0 0 0-8.31 4.93 11.55 11.55 0 0 0-19.48 0A9.47 9.47 0 0 0 22 21h-.78a10.7 10.7 0 1 0-10.63 0H9.48A9.49 9.49 0 0 0 0 30.45v23.27a1.5 1.5 0 0 0 3 0V30.45A6.49 6.49 0 0 1 9.48 24H22a6.49 6.49 0 0 1 6.48 6.48c.003.146.027.29.07.43 0 .41-.07.82-.07 1.25a11.58 11.58 0 0 0 6.31 10.29h-5.67c-5.641.005-10.218 4.569-10.24 10.21v26.69a1.5 1.5 0 0 0 3 0V52.66a7.25 7.25 0 0 1 7.24-7.24h21.76a7.25 7.25 0 0 1 7.24 7.24v26.69a1.5 1.5 0 0 0 3 0V52.66c-.006-5.653-4.587-10.234-10.24-10.24h-5.62a11.58 11.58 0 0 0 6.31-10.29c0-.43 0-.84-.07-1.25a1.55 1.55 0 0 0 .07-.43A6.49 6.49 0 0 1 58.05 24h12.47A6.49 6.49 0 0 1 77 30.45v23.27a1.5 1.5 0 0 0 3 0V30.45A9.49 9.49 0 0 0 70.52 21zm-14.08-9.3a7.7 7.7 0 1 1 7.7 7.7 7.71 7.71 0 0 1-7.7-7.7zm-48.28 0a7.7 7.7 0 1 1 15.4 0 7.7 7.7 0 0 1-15.4 0zM40 40.7a8.57 8.57 0 1 1 8.57-8.57A8.58 8.58 0 0 1 40 40.7z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.2a76a221106139221aea78ccaffd56d2.svg";
export { ForwardRef as ReactComponent };